export default __webpack_public_path__ + "static/media/text-logo-grey.2b78add0.svg";